module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "in-none"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/40.png")
    }
  }), _vm._v(" "), _c('h2', [_vm._v("今天没有预约的病人,休息一下吧")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c53317d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/inquiry/inquiryNone.vue
// module id = 997
// module chunks = 2